var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#7152EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.974 6.492C9.57267 6.492 9.274 6.408 9.078 6.24C8.882 6.06267 8.784 5.806 8.784 5.47C8.784 5.12467 8.882 4.868 9.078 4.7C9.274 4.52267 9.57267 4.434 9.974 4.434C10.3753 4.434 10.674 4.52267 10.87 4.7C11.066 4.868 11.164 5.12467 11.164 5.47C11.164 5.806 11.066 6.06267 10.87 6.24C10.674 6.408 10.3753 6.492 9.974 6.492ZM10.926 7.5V14.5H9.008V7.5H10.926Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmInfo);
export default __webpack_public_path__ + "static/media/cmInfo.978154121f70000a9cb9b04270867281.svg";
export { ForwardRef as ReactComponent };